import { render } from "./CustomerViewMostPurchased.vue?vue&type=template&id=7d8c8b72&scoped=true"
import script from "./CustomerViewMostPurchased.vue?vue&type=script&lang=js"
export * from "./CustomerViewMostPurchased.vue?vue&type=script&lang=js"

import "./CustomerViewMostPurchased.vue?vue&type=style&index=0&id=7d8c8b72&lang=scss&scoped=true"
import "./CustomerViewMostPurchased.vue?vue&type=style&index=1&id=7d8c8b72&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8c8b72"]])

export default __exports__